module.exports = __webpack_public_path__ + "img/senias-datensatz-detail-1.34e703c2.png";